import { render, staticRenderFns } from "./UserCreateAccount.vue?vue&type=template&id=44ba37bc&"
import script from "./UserCreateAccount.vue?vue&type=script&lang=js&"
export * from "./UserCreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VResponsive})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ba37bc')) {
      api.createRecord('44ba37bc', component.options)
    } else {
      api.reload('44ba37bc', component.options)
    }
    module.hot.accept("./UserCreateAccount.vue?vue&type=template&id=44ba37bc&", function () {
      api.rerender('44ba37bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserCreateAccount.vue"
export default component.exports